import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="w-full md:min-w-[390px] text-center py-4 bg-primary text-secondary">
    <p>&copy; {new Date().getFullYear()} Elevate LLC. All Rights Reserved</p>
    <Link
      to="/TermsOfService"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="underline"
    >Terms of Service</Link>
  </footer>
);

export default Footer;
